"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GLCodingHistory {
}
exports.GLCodingHistory = GLCodingHistory;
//# sourceMappingURL=GlHistory.js.map